export const SET_REGISTRATION_BADGE = "SET_REGISTRATION_BADGE";
export const SET_EMAIL_BADGE = "SET_EMAIL_BADGE";
export const SET_COMMUNICATION_BADGE = "SET_COMMUNICATION_BADGE";
export const SET_COMMUNICATION_BADGE_LOADING = "SET_COMMUNICATION_BADGE_LOADING";
export const SET_COMMUNICATION_BADGE_SUCCESS = "SET_COMMUNICATION_BADGE_SUCCESS";
